// Popup thể lệ dùng hook CHUẨN của libraryMainsite: nút mở mang
// `MJ__openIframe MJ__toogleActive` + `data-link` + `data-iframe="#popup_rule iframe"` + `data-target="#popup_rule"`,
// lib tự nạp link mới vào iframe lúc bấm sao.
//
// Bổ sung: lib CHỈ lo phần "chèn link mới" lúc mở, không lo phần đóng — nút X/overlay chỉ
// remove class "active", không đụng iframe.src. Trên Safari/iOS ghi nhận: đóng rồi mở lại vẫn
// dính nội dung cũ trong iframe. Chốt theo yêu cầu: đóng popup thì CHỦ ĐỘNG xoá src (remove link),
// để lần mở kế tiếp luôn là 1 lượt chèn link mới hoàn toàn, không dựa vào set lại src y hệt/khác.
$(function () {
	$(document).on("click", "#popup_rule .MJ__close-popup", function () {
		$("#popup_rule iframe").attr("src", "");
	});
});
